interface IOverlayConfig {
  overlay: HTMLElement,
  selectors: IOverlaySelectors,
  classNames: IOverlayClassNames
}

interface IOverlaySelectors {
  overlay: string
}

interface IOverlayClassNames {
  on: string
}

class Overlay {

  public config: IOverlayConfig;

  constructor() {
    this.config = {
      overlay: null,
      selectors: {
        overlay: '[data-overlay]'
      },
      classNames: {
        on: 'overlay--on'
      }
    }
  }

  public init() {
    this.config.overlay = document.querySelector(this.config.selectors.overlay);
  }

  public on(zIndex?: number) {
    this.config.overlay.style.zIndex = zIndex ? zIndex.toString() : this.config.overlay.style.zIndex;
    this.config.overlay.classList.add(this.config.classNames.on);
  }

  public off() {
    this.config.overlay.classList.remove(this.config.classNames.on);
  }
}

export default new Overlay();